import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ProductCard from "./ProductCard";
import VideoCard from "./VideoCard";
import HeroCard from "./HeroCard";
import "./style.scss";

const Card = ({ type, cardContent, cardSize, cardAspect, cardGridArea }) => {
  const cardClasses = classNames(
    `card card--${type}--${cardAspect}--${cardSize} ${
      cardGridArea ? `grid-area-${cardGridArea}` : ""
    }`
  );

  return (
    <div
      className={cardClasses}
      style={{
        maxHeight: window
          ? `${(window.screen.availHeight / 3) * 2}px`
          : undefined
      }}
    >
      {type === "product" && (
        <ProductCard {...cardContent} cardClasses={cardClasses} />
      )}
      {type === "video" && (
        <VideoCard {...cardContent} cardClasses={cardClasses} />
      )}
      {type === "hero" && (
        <HeroCard {...cardContent} cardClasses={cardClasses} />
      )}
    </div>
  );
};

Card.propTypes = {
  type: PropTypes.oneOf(["product", "hero", "video"]).isRequired,
  cardSize: PropTypes.oneOf(["large", "small", "mixed"]),
  cardGridArea: PropTypes.oneOf(["a", "b", "c"]),
  cardAspect: PropTypes.oneOf(["portrait", "landscape"]),
  cardContent: PropTypes.object.isRequired
};

Card.defaultProps = {
  cardSize: "small",
  cardGridArea: undefined,
  cardAspect: "portrait"
};

export default Card;
